import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "px-4 pb-4 tw" }
const _hoisted_2 = { class: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-gray-500 mt-0.5"
}
const _hoisted_4 = {
  key: 0,
  class: "px-7 py-5",
  "data-cy": "liens-unpushed-card"
}
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-gray-500 mt-0.5"
}
const _hoisted_6 = {
  key: 1,
  "data-testid": "skeleton"
}
const _hoisted_7 = {
  key: 2,
  class: "flex items-center gap-3 bg-[rgba(var(--v-theme-error),0.08)] border border-[rgb(var(--v-theme-error))] rounded-lg px-4 py-3 text-sm text-error mt-4",
  "data-cy": "liens-error-banner"
}
const _hoisted_8 = {
  key: 3,
  class: "text-center py-16 text-gray-500"
}
const _hoisted_9 = { style: {"white-space":"pre-line"} }
const _hoisted_10 = { class: "flex items-center justify-end mb-4" }
const _hoisted_11 = { style: {"white-space":"pre-line"} }
const _hoisted_12 = {
  class: "flex flex-wrap items-center justify-between gap-3 px-4 py-3 mb-3 bg-gray-50 border border-gray-200 rounded-lg",
  "data-cy": "lien-bulk-action-bar"
}
const _hoisted_13 = { class: "text-sm text-gray-400" }
const _hoisted_14 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_15 = { class: "bg-white rounded-lg shadow overflow-hidden relative" }
const _hoisted_16 = {
  key: 0,
  class: "absolute inset-0 z-10 flex items-center justify-center bg-white/60",
  "data-cy": "liens-loading-overlay"
}
const _hoisted_17 = { class: "overflow-x-auto" }
const _hoisted_18 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_19 = { class: "bg-gray-50" }
const _hoisted_20 = ["data-cy", "onClick"]
const _hoisted_21 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_22 = ["data-cy", "onClick"]
const _hoisted_23 = { class: "px-6 py-3 text-sm" }
const _hoisted_24 = { class: "font-medium text-gray-900" }
const _hoisted_25 = { class: "px-6 py-3 text-sm text-gray-500" }
const _hoisted_26 = { class: "px-6 py-3 text-sm text-gray-700" }
const _hoisted_27 = { class: "px-6 py-3 text-sm text-gray-700 text-right" }
const _hoisted_28 = { class: "px-6 py-3 text-sm text-gray-700 text-right" }
const _hoisted_29 = {
  key: 1,
  class: "text-gray-300"
}
const _hoisted_30 = { class: "px-6 py-3 text-sm font-semibold text-gray-900 text-right" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs font-medium text-green-600 mt-0.5"
}
const _hoisted_32 = {
  class: "px-6 py-3 text-sm text-gray-700",
  "data-cy": "lien-start-date"
}
const _hoisted_33 = {
  class: "px-6 py-3 text-sm text-gray-700",
  "data-cy": "lien-end-date"
}
const _hoisted_34 = { class: "px-6 py-3 text-center" }
const _hoisted_35 = { style: {"white-space":"pre-line"} }
const _hoisted_36 = {
  key: 0,
  class: "flex items-center justify-center gap-1.5 text-xs text-gray-500 mt-1"
}
const _hoisted_37 = {
  key: 1,
  class: "text-xs text-gray-400 tabular-nums mt-1",
  "data-cy": "lien-qbo-ref"
}
const _hoisted_38 = {
  key: 3,
  class: "flex items-start gap-1 text-xs text-error mt-1",
  "data-cy": "lien-bulk-error"
}
const _hoisted_39 = { style: {"white-space":"normal"} }
const _hoisted_40 = { style: {"max-width":"260px"} }
const _hoisted_41 = { style: {"max-width":"260px"} }
const _hoisted_42 = { class: "relative z-10" }

import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useLienStore } from '@/stores/useLienStore';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { formatCurrency, pluralizeWithCount } from '@/services/utils';
import RouteService from '@/services/RouteService';
import type { LienData, LienStatus, LienBulkResponse } from '@/models/lienTypes';
import { LIEN_STATUS_OPTIONS, LIEN_STATUS_LABELS, STATUS_DOT_COLORS, STATUS_STYLES } from '@/constants/lienConstants';
import { resolveQboPushError, isFinalized, isPushBlocked, isPushed, pushBadgeState } from '@/utils/lienHelpers';
import { parseISO, format, isValid } from 'date-fns';
import EventTracker from '@/services/eventTracker';
import LienFormPanel from './LienFormPanel.vue';
import LienPushConfirmDialog from './liens/LienPushConfirmDialog.vue';
import LienPushErrorDialog from './liens/LienPushErrorDialog.vue';
import LienPushBlockedItem from './liens/LienPushBlockedItem.vue';
import LienBulkPushPreviewDialog from './liens/LienBulkPushPreviewDialog.vue';
import { useLienSelection } from './liens/useLienSelection';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import SimplePagination from '@/components/SimplePagination.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import AlertBar from '@/components/AlertBar.vue';
import QboIcon from '@/components/QboIcon.vue';

type SummaryMetric = { label: string; value: string | number; valueClass: string; sublabel?: string };

const BULK_PUSH_ALL_BLOCKED =
  'The trust balance is too low to cover the selected liens. Add funds to trust before submitting.';

const pushedStatusTooltip =
  'This lien has been submitted to QuickBooks. Undo the submission before changing its status.';

// Pagination
type ColumnDef = {
  label: string;
  dataCy: string;
  orderBy?: string;
  align: 'left' | 'right' | 'center';
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MatterLiensTab',
  props: {
    stateParams: {},
    state: {},
    tracking: {}
  },
  setup(__props: any) {

const props = __props;

const routeService = new RouteService(props);

const lienStore = useLienStore();
const clientMatterStore = useClientMatterStore();
const { liens, count, summary, isSettlementLocked, isQboConnected, uiState } =
  storeToRefs(lienStore);
const { handleError, handleSuccess, handleWarning } = useSnackbarHandler();

const matterName = ref<string | null>(null);

const matterId = computed<string | null>(
  () => props.stateParams?.matterId ?? props.stateParams?.id ?? null,
);

// Panel state
const panelOpen = ref(false);
const activeLien = ref<LienData | null>(null);
const deleteConfirmRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(
  null,
);
const deleteMessage = ref('Delete this lien? This action cannot be undone.');

// ── Selection + bulk QBO state ───────────────────────────────────────────
const {
  selectedIds,
  selectedLiens,
  allSelected,
  someSelected,
  hasPushableSelected,
  hasUndoableSelected,
  hasAnyPushableOrUndoable,
  pushableSelectedIds,
  blockedSelectedCount,
  undoableSelectedIds,
  isSelected,
  toggle,
  toggleAll,
  clear: clearSelection,
  prune: pruneSelection,
  canRetryLien,
  canUndoLien,
  isPushActionable,
} = useLienSelection(liens, isSettlementLocked);

const pushingIds = reactive(new Set<string>());
const undoingIds = reactive(new Set<string>());
const isBulkPushing = ref(false);
const isBulkUndoing = ref(false);

// Promise-based dialogs. Reusable confirms for undo (destructive → red CTA);
// the push preview is bespoke because it needs currency amounts + a green CTA.
const pushConfirmRef = ref<InstanceType<typeof LienPushConfirmDialog> | null>(null);
const pushErrorRef = ref<InstanceType<typeof LienPushErrorDialog> | null>(null);
const bulkPushPreviewRef = ref<InstanceType<typeof LienBulkPushPreviewDialog> | null>(null);
const bulkUndoConfirmRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(null);
const bulkDeleteConfirmRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(null);
const undoConfirmRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(null);

const undoDialog = ref({ message: '' });
const bulkUndo = ref({ message: '' });

// Per-lien bulk error messages, keyed by lienId. Populated from a bulk op's
// `results[].error` and rendered inline in the QBO Push cell — because a failed
// undo leaves the row `pushed` and some failed pushes never persist a `failed`
// status, so the error has no inline row state of its own to live on.
const bulkErrors = ref<Record<string, string>>({});

// QBO column/actions require an active QuickBooks connection.
const showQboColumn = computed(() => isQboConnected.value);

// The 4 uniform summary-bar cards (Total Liens / Current Total / Original
// Total / Savings). The 5th "Unpushed" card is conditionally visible/colored
// and stays hand-written in the template.
const summaryMetrics = computed<SummaryMetric[]>(() => {
  if (!summary.value) return [];
  return [
    { label: 'Total Liens', value: summary.value.totalLiens, valueClass: 'text-gray-900' },
    { label: 'Current Total', value: formatCurrency(summary.value.totalCurrentAmount), valueClass: 'text-gray-900' },
    { label: 'Original Total', value: formatCurrency(summary.value.totalOriginalAmount), valueClass: 'text-gray-900' },
    {
      label: 'Savings',
      value: formatCurrency(summary.value.totalSavings),
      valueClass: 'text-green-700',
      sublabel: `${Number(summary.value.savingsPercentage).toFixed(2)}% reduction`,
    },
  ];
});

// "Unpushed (Finalized)" summary card (QBO only). Derived from loaded liens.
const unpushedSummary = computed(() => {
  const unpushed = liens.value.filter((l) => isFinalized(l.status));
  return {
    count: unpushed.length,
    value: unpushed.reduce((sum, l) => sum + (l.currentAmount ?? 0), 0),
  };
});

function isRowPushing(lienId: string): boolean {
  return pushingIds.has(lienId);
}

function isRowUndoing(lienId: string): boolean {
  return undoingIds.has(lienId);
}

// Shared by the row checkbox and the kebab-menu trigger: once locked, a row
// stays interactive only for the push/undo action it's still eligible for.
function isRowSelectionLocked(lien: LienData): boolean {
  return isSettlementLocked.value && !isPushActionable(lien) && !canUndoLien(lien);
}

function pushActionLabel(lien: LienData): string {
  return canRetryLien(lien) ? 'Retry Submit' : 'Submit to QuickBooks';
}

function clearLienIdParam(): void {
  routeService.go('.', { lienId: null }, { notify: false, reload: false });
}

function openAdd(): void {
  activeLien.value = null;
  panelOpen.value = true;
  clearLienIdParam();
}

async function openEdit(lien: LienData): Promise<void> {
  if (isSettlementLocked.value) return;
  // If panel is already open, close first so the Transition animates out/in
  if (panelOpen.value) {
    panelOpen.value = false;
    await new Promise((r) => setTimeout(r, 50));
  }
  activeLien.value = lien;
  panelOpen.value = true;
  routeService.go(
    '.',
    { lienId: lien.lienId },
    { notify: false, reload: false },
  );
}

function closePanel(): void {
  panelOpen.value = false;
  activeLien.value = null;
  clearLienIdParam();
}

async function onSaved(): Promise<void> {
  // Panel closes itself via LienFormPanel.submit() → close()
  activeLien.value = null;
  clearLienIdParam();
  if (matterId.value) {
    await lienStore.fetchLiens(matterId.value);
  }
}

async function confirmDelete(lien: LienData): Promise<void> {
  if (!matterId.value) return;
  deleteMessage.value = `Delete lien for "${lien.vendorDisplayName}"? This action cannot be undone.`;
  const confirmed = await deleteConfirmRef.value?.open();
  if (!confirmed) return;
  try {
    await lienStore.deleteLien(lien.lienId);
    if (props.tracking) {
      EventTracker.trackEvent(props.tracking, 'Lien', 'Deleted', {
        matterId: matterId.value,
        lienId: lien.lienId,
        lienType: lien.lienType,
        status: lien.status,
      });
    }
    await lienStore.fetchLiens(matterId.value);
    pruneSelection();
  } catch {
    // error handled in store
  }
}

// ── QBO Submit / undo (single) ─────────────────────────────────────────────
// Row action → confirmation modal → execute (matches the V2 prototype's Submit-modal).
async function handleRowPush(lien: LienData): Promise<void> {
  const confirmed = await pushConfirmRef.value?.open(lien);
  if (!confirmed) return;
  await executePush(lien);
}

async function executePush(lien: LienData): Promise<void> {
  if (!matterId.value || isRowPushing(lien.lienId)) return;
  pushingIds.add(lien.lienId);
  try {
    const updated = await lienStore.pushLien(matterId.value, lien.lienId);
    // The push endpoint may report a handled failure on the returned lien
    // (status stays Finalized + qboPushError populated) rather than throwing.
    if (pushBadgeState(updated) === 'failed') {
      handleError(resolveQboPushError(updated.qboPushError, updated.qboPushError));
    } else {
      handleSuccess(`${lien.vendorDisplayName} submitted to QuickBooks`);
      clearBulkError(lien.lienId);
      trackQbo('Push', lien, { bulk: false });
    }
  } catch (e: unknown) {
    handleError(e);
  } finally {
    pushingIds.delete(lien.lienId);
  }
}

// Failed-lien "Details" link → error detail modal → optional retry.
async function openErrorDetail(lien: LienData): Promise<void> {
  const action = await pushErrorRef.value?.open(lien);
  if (action === 'retry') await executePush(lien);
}

async function handleRowUndo(lien: LienData): Promise<void> {
  if (!matterId.value) return;
  undoDialog.value = {
    message:
      `This will delete the QuickBooks trust check${
        lien.qboTransactionId ? ` (${lien.qboTransactionId})` : ''
      } for "${lien.vendorDisplayName}" — ${formatCurrency(lien.currentAmount)} and revert the lien to Finalized.`,
  };
  const confirmed = await undoConfirmRef.value?.open();
  if (!confirmed) return;
  undoingIds.add(lien.lienId);
  try {
    await lienStore.undoPush(matterId.value, lien.lienId);
    handleSuccess(`Submission undone for ${lien.vendorDisplayName}`);
    clearBulkError(lien.lienId);
    trackQbo('Undo', lien, { bulk: false });
  } catch (e: unknown) {
    handleError(resolveQboPushError(errorKeyOf(e), messageOf(e)));
  } finally {
    undoingIds.delete(lien.lienId);
  }
}

// ── QBO push / undo (bulk) ────────────────────────────────────────────────
async function handleBulkPush(): Promise<void> {
  if (!matterId.value || !hasPushableSelected.value) return;
  const ids = pushableSelectedIds.value;
  const preview = selectedLiens.value.filter((l) => ids.includes(l.lienId));
  const confirmed = await bulkPushPreviewRef.value?.open(preview);
  if (!confirmed) return;
  isBulkPushing.value = true;
  try {
    const skipped = blockedSelectedCount.value;
    const response = await lienStore.bulkPushLiens(matterId.value, ids);
    applyBulkErrors(response);
    showBulkToast(response, 'push');
    if (skipped > 0) {
      handleWarning(
        `${pluralizeWithCount(skipped, 'lien')} not submitted — the trust balance is too low to cover ${skipped === 1 ? 'it' : 'them'}.`,
      );
    }
    await afterBulkOperation('Push', response, { count: ids.length });
  } catch (e: unknown) {
    handleError(e);
  } finally {
    isBulkPushing.value = false;
  }
}

async function handleBulkUndo(): Promise<void> {
  if (!matterId.value || !hasUndoableSelected.value) return;
  const ids = undoableSelectedIds.value;
  bulkUndo.value = {
    message:
      `This will delete the QuickBooks trust checks for the following ` +
      `${pluralizeWithCount(ids.length, 'lien')} and revert them to Finalized. ` +
      'Reconciled checks cannot be undone and will be reported as failed.',
  };
  const confirmed = await bulkUndoConfirmRef.value?.open();
  if (!confirmed) return;
  isBulkUndoing.value = true;
  try {
    const response = await lienStore.bulkUndoPush(matterId.value, ids);
    applyBulkErrors(response);
    showBulkToast(response, 'undo');
    await afterBulkOperation('Undo', response, { count: ids.length });
  } catch (e: unknown) {
    handleError(e);
  } finally {
    isBulkUndoing.value = false;
  }
}

// ── Bulk delete (local action — no QBO endpoint) ──────────────────────────
async function handleBulkDelete(): Promise<void> {
  if (!matterId.value || isSettlementLocked.value || selectedIds.value.length === 0) return;
  const targets = selectedLiens.value.filter((l) => !isPushed(l.status));
  if (targets.length === 0) {
    handleWarning('Selected liens have been submitted to QuickBooks and cannot be deleted. Undo the submission first.');
    return;
  }
  const confirmed = await bulkDeleteConfirmRef.value?.open();
  if (!confirmed) return;
  try {
    // Local delete has no bulk endpoint; the "no frontend loop" rule applies
    // only to QBO push/undo. Settled so one failure doesn't abort the rest.
    const outcomes = await Promise.allSettled(
      targets.map((l) => lienStore.deleteLien(l.lienId)),
    );
    const deleted = outcomes.filter((o) => o.status === 'fulfilled').length;
    const failed = outcomes.length - deleted;
    if (props.tracking) {
      EventTracker.trackEvent(props.tracking, 'Lien', 'Bulk Deleted', {
        matterId: matterId.value,
        requested: targets.length,
        deleted,
        failed,
      });
    }
    if (failed > 0) handleWarning(`Deleted ${deleted} of ${targets.length}; ${failed} failed.`);
    else handleSuccess(`${pluralizeWithCount(deleted, 'lien')} deleted`);
  } catch (e: unknown) {
    handleError(e);
  } finally {
    clearSelection();
    await lienStore.fetchLiens(matterId.value);
  }
}

function showBulkToast(response: LienBulkResponse, op: 'push' | 'undo'): void {
  const { succeeded, failed, skipped } = response;
  const noun = 'lien';
  const pastVerb = op === 'push' ? 'submitted to QuickBooks' : 'reverted to Finalized';
  if (failed === 0) {
    const parts = [`${pluralizeWithCount(succeeded, noun)} ${pastVerb}`];
    if (skipped > 0) parts.push(`${pluralizeWithCount(skipped, 'lien')} skipped`);
    handleSuccess(parts.join(', '));
  } else if (succeeded === 0) {
    handleError(`All ${pluralizeWithCount(failed, noun)} failed — see inline errors in the table`);
  } else {
    handleWarning(`${pluralizeWithCount(succeeded, noun)} ${pastVerb}, ${pluralizeWithCount(failed, 'lien')} failed — see inline errors in the table`);
  }
}

// Capture each failed lien's error so it renders inline on its row (see the QBO Push cell).
function applyBulkErrors(response: LienBulkResponse): void {
  const errors: Record<string, string> = {};
  response.results.forEach((r) => {
    if (r.error) errors[r.lienId] = resolveQboPushError(r.error);
  });
  bulkErrors.value = errors;
}

async function afterBulkOperation(
  action: 'Push' | 'Undo',
  response: LienBulkResponse,
  meta: { count: number },
): Promise<void> {
  if (props.tracking && matterId.value) {
    EventTracker.trackEvent(props.tracking, 'Lien', `Bulk ${action}`, {
      matterId: matterId.value,
      requested: meta.count,
      success: response.succeeded,
      failed: response.failed,
      skipped: response.skipped,
    });
  }
  clearSelection();
  if (matterId.value) await lienStore.fetchLiens(matterId.value);
}

function trackQbo(
  action: 'Push' | 'Undo',
  lien: LienData,
  meta: { bulk: boolean },
): void {
  if (!props.tracking || !matterId.value) return;
  EventTracker.trackEvent(props.tracking, 'Lien', action, {
    matterId: matterId.value,
    lienId: lien.lienId,
    lienType: lien.lienType,
    bulk: meta.bulk,
  });
}

function errorKeyOf(e: unknown): string | null {
  return (e as { response?: { data?: { error?: string } } })?.response?.data?.error ?? null;
}
function messageOf(e: unknown): string | null {
  return (e as { response?: { data?: { message?: string } } })?.response?.data?.message ?? null;
}

const lockTooltip = [
  'Liens for this matter are locked because the lien amounts',
  'have already been finalized in the settlement calculator.',
  'Please restart the settlement flow if you need to make any',
  'changes to these liens.',
].join('\n');

const currentPage = computed({
  get: () =>
    Math.floor(lienStore.pagination.offset / lienStore.pagination.limit) + 1,
  set: () => {},
});

function onPageChange(page: number): void {
  if (matterId.value) {
    clearSelection();
    bulkErrors.value = {};
    lienStore.setPage(page, matterId.value);
  }
}

// Sorting
const COLUMN_DEFS: ColumnDef[] = [
  { label: 'Payee', dataCy: 'lien-header-payee', orderBy: 'vendorDisplayName', align: 'left' },
  { label: 'Description', dataCy: 'lien-header-description', orderBy: 'description', align: 'left' },
  { label: 'Type', dataCy: 'lien-header-type', orderBy: 'lienType', align: 'left' },
  { label: 'Original', dataCy: 'lien-header-original', orderBy: 'originalAmount', align: 'right' },
  { label: 'Negotiated', dataCy: 'lien-header-negotiated', orderBy: 'negotiatedAmount', align: 'right' },
  { label: 'Current', dataCy: 'lien-header-current', orderBy: 'currentAmount', align: 'right' },
  { label: 'Service Start Date', dataCy: 'lien-start-date-header', orderBy: 'dateOfService', align: 'left' },
  { label: 'Service End Date', dataCy: 'lien-end-date-header', orderBy: 'dateOfServiceEnd', align: 'left' },
  { label: 'Status', dataCy: 'lien-header-status', orderBy: 'status', align: 'center' },
];

const COLUMN_ALIGN_CLASS: Record<ColumnDef['align'], string> = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
};

function onSortClick(orderBy: string): void {
  if (!matterId.value) return;
  clearSelection();
  bulkErrors.value = {};
  lienStore.setSort(orderBy, matterId.value);
}

function sortIcon(orderBy: string): string | null {
  if (lienStore.pagination.orderBy !== orderBy) return null;
  return lienStore.pagination.sortAscending ? 'mdi-arrow-up' : 'mdi-arrow-down';
}

/** Drop the inline bulk error for a lien once it's individually resolved. */
function clearBulkError(lienId: string): void {
  if (bulkErrors.value[lienId]) {
    const next = { ...bulkErrors.value };
    delete next[lienId];
    bulkErrors.value = next;
  }
}

// Selection is component-local — clear it when leaving the tab.
onBeforeUnmount(() => clearSelection());

// Formatting helpers
function fmtDate(iso: string | null): string {
  if (!iso) return '—';
  const d = parseISO(iso);
  return isValid(d) ? format(d, 'MM/dd/yyyy') : '—';
}

async function changeStatus(
  lien: LienData,
  newStatus: LienStatus,
): Promise<void> {
  if (newStatus === lien.status || !matterId.value) return;
  const oldStatus = lien.status;
  try {
    await lienStore.updateLienStatus(lien.lienId, newStatus);
    if (props.tracking) {
      EventTracker.trackEvent(props.tracking, 'Lien', 'Status Changed', {
        matterId: matterId.value,
        lienId: lien.lienId,
        oldStatus,
        newStatus,
        lienType: lien.lienType,
      });
    }
    // Only Finalized liens carry a pushBlockedReason, so only entering or leaving it needs the
    // list (and its live trust read) reloaded.
    if (isFinalized(oldStatus) || isFinalized(newStatus)) {
      await lienStore.fetchLiens(matterId.value);
    }
  } catch {
    // error handled in store
  }
}

// Init
onMounted(async () => {
  if (matterId.value) {
    const [matter] = await Promise.all([
      clientMatterStore.getMatterById(matterId.value).catch(() => null),
      lienStore.fetchLiens(matterId.value),
    ]);
    matterName.value = (matter as { name?: string } | null)?.name ?? null;

    // Track tab viewed after data loads (not during skeleton)
    if (props.tracking && !uiState.value.error) {
      EventTracker.trackEvent(props.tracking, 'Liens', 'Tab Viewed', {
        matterId: matterId.value,
        lienCount: count.value,
      });
    }

    // Auto-open edit panel if lienId is in the URL
    const lienId = props.stateParams?.lienId;
    if (lienId) {
      const lien =
        liens.value.find((l) => l.lienId === lienId) ??
        await lienStore.fetchLienById(lienId).catch((): null => null);
      if (lien) {
        openEdit(lien);
      }
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LienFormPanel, {
      "model-value": panelOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = 
        (val) => {
          if (!val) closePanel();
          else panelOpen.value = val;
        }
      ),
      "matter-id": matterId.value,
      "matter-name": matterName.value,
      lien: activeLien.value,
      tracking: props.tracking,
      onSaved: onSaved
    }, null, 8, ["model-value", "matter-id", "matter-name", "lien", "tracking"]),
    (_unref(summary) && _unref(liens).length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["grid divide-x divide-gray-200 bg-white border border-gray-200 rounded-lg px-0 mb-4", showQboColumn.value ? 'grid-cols-5' : 'grid-cols-4']),
          "data-cy": "liens-summary-bar"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryMetrics.value, (metric) => {
            return (_openBlock(), _createElementBlock("div", {
              key: metric.label,
              class: "px-7 py-5"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(metric.label), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["text-2xl font-bold tabular-nums", metric.valueClass])
              }, _toDisplayString(metric.value), 3),
              (metric.sublabel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(metric.sublabel), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (showQboColumn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" }, " Unsubmitted (Finalized) ", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-2xl font-bold tabular-nums", unpushedSummary.value.count > 0 ? 'text-error' : 'text-gray-900'])
                }, _toDisplayString(unpushedSummary.value.count), 3),
                (unpushedSummary.value.count > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(formatCurrency)(unpushedSummary.value.value)) + " awaiting submission ", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(uiState).loading && !_unref(liens).length && !_unref(summary))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_skeleton_loader, {
            type: "heading",
            class: "mb-4",
            elevation: "0"
          }),
          _createVNode(_component_v_skeleton_loader, {
            type: "table-row-divider@5",
            class: "w-full",
            elevation: "0"
          })
        ]))
      : (_unref(uiState).error && !_unref(uiState).loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "error"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("mdi-alert-circle", -1)
              ]))]),
              _: 1
            }),
            _cache[8] || (_cache[8] = _createTextVNode(" Unable to load liens. Try refreshing. ", -1))
          ]))
        : (!_unref(liens).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-5xl mb-4 opacity-40" }, "📋", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-base font-semibold text-gray-900 mb-2" }, " No liens recorded for this matter ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm mb-5 max-w-md mx-auto" }, " Liens allow you to track amounts owed to medical providers, insurance companies, and other third parties from the settlement. ", -1)),
              _createVNode(LlTooltip, {
                location: "top",
                disabled: !_unref(isSettlementLocked)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(lockTooltip)), 1)
                ]),
                activator: _withCtx(() => [
                  _createVNode(LlSecondaryButton, {
                    color: "primary",
                    "prepend-icon": "mdi-plus",
                    disabled: _unref(isSettlementLocked),
                    "data-cy": "add-lien-empty",
                    onClick: openAdd
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Add Lien ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              (_unref(isSettlementLocked))
                ? (_openBlock(), _createBlock(AlertBar, {
                    key: 0,
                    type: "info",
                    variant: "tonal",
                    class: "mb-4",
                    "data-cy": "liens-locked-banner"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("span", { class: "font-weight-bold" }, "Liens are locked.", -1),
                      _createTextVNode(" These lien amounts have been finalized in the settlement calculator. Restart the settlement flow to make changes. ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(LlTooltip, {
                  location: "top",
                  disabled: !_unref(isSettlementLocked)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(lockTooltip)), 1)
                  ]),
                  activator: _withCtx(() => [
                    _createVNode(LlSecondaryButton, {
                      color: "primary",
                      "prepend-icon": "mdi-plus",
                      disabled: _unref(isSettlementLocked),
                      "data-cy": "add-lien",
                      onClick: openAdd
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode(" Add Lien ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("span", {
                  class: "text-sm font-medium px-2.5 py-1 rounded-md border text-green-700 bg-green-50 border-green-600",
                  "data-cy": "lien-selection-badge"
                }, _toDisplayString(_unref(pluralizeWithCount)(_unref(selectedIds).length, 'lien')) + " selected ", 513), [
                  [_vShow, _unref(selectedIds).length > 0]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_13, " Select liens to submit, undo, or delete in bulk ", 512), [
                  [_vShow, _unref(selectedIds).length === 0]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (showQboColumn.value)
                    ? (_openBlock(), _createBlock(LlTooltip, {
                        key: 0,
                        text: !_unref(hasPushableSelected) && _unref(blockedSelectedCount) > 0 ? BULK_PUSH_ALL_BLOCKED : '',
                        location: "bottom"
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(LlSecondaryButton, {
                            variant: "outlined",
                            color: "primary",
                            disabled: !_unref(hasPushableSelected) || isBulkPushing.value,
                            loading: isBulkPushing.value,
                            "data-cy": "bulk-push-selected",
                            onClick: handleBulkPush
                          }, {
                            default: _withCtx(() => [
                              (!isBulkPushing.value)
                                ? (_openBlock(), _createBlock(QboIcon, {
                                    key: 0,
                                    size: 16,
                                    class: "mr-2"
                                  }))
                                : _createCommentVNode("", true),
                              _cache[15] || (_cache[15] = _createTextVNode(" Submit Selected to QuickBooks ", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (showQboColumn.value)
                    ? (_openBlock(), _createBlock(LlSecondaryButton, {
                        key: 1,
                        variant: "outlined",
                        color: "orange-darken-1",
                        disabled: !_unref(hasUndoableSelected) || isBulkUndoing.value,
                        loading: isBulkUndoing.value,
                        "data-cy": "bulk-undo-selected",
                        onClick: handleBulkUndo
                      }, {
                        default: _withCtx(() => [
                          (!isBulkUndoing.value)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                size: "16",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode("mdi-undo", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _cache[17] || (_cache[17] = _createTextVNode(" Undo Selected in QuickBooks ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"]))
                    : _createCommentVNode("", true),
                  _createVNode(LlSecondaryButton, {
                    variant: "outlined",
                    color: "error",
                    "prepend-icon": "mdi-delete",
                    disabled: _unref(selectedIds).length === 0 || _unref(isSettlementLocked),
                    "data-cy": "bulk-delete-selected",
                    onClick: handleBulkDelete
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode(" Delete ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(LlSecondaryButton, {
                    variant: "outlined",
                    disabled: _unref(selectedIds).length === 0,
                    "data-cy": "bulk-clear-selection",
                    onClick: _unref(clearSelection)
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode(" Clear Selection ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_unref(uiState).loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        size: "32",
                        width: "3",
                        color: "success"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", _hoisted_19, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "px-4 py-3 w-10",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(LlCheckbox, {
                            "model-value": _unref(allSelected),
                            indeterminate: _unref(someSelected),
                            "aria-label": "Select all liens",
                            disabled: _unref(isSettlementLocked) && !_unref(hasAnyPushableOrUndoable),
                            "data-cy": "lien-select-all",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _unref(toggleAll)(!!v))
                          }, null, 8, ["model-value", "indeterminate", "disabled"])
                        ]),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COLUMN_DEFS, (col) => {
                          return _createElementVNode("th", {
                            key: col.orderBy,
                            class: _normalizeClass([COLUMN_ALIGN_CLASS[col.align], 'px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer select-none']),
                            "data-cy": col.dataCy,
                            onClick: ($event: any) => (onSortClick(col.orderBy!))
                          }, [
                            _createTextVNode(_toDisplayString(col.label) + " ", 1),
                            (sortIcon(col.orderBy!))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  icon: sortIcon(col.orderBy!),
                                  size: "14",
                                  class: "ml-1",
                                  "data-cy": "lien-sort-arrow"
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_20)
                        }), 64)),
                        _cache[20] || (_cache[20] = _createElementVNode("th", { class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Actions ", -1))
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(liens), (lien) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: lien.lienId,
                          class: _normalizeClass([
                _unref(isSettlementLocked) ? '' : 'cursor-pointer hover:bg-gray-50',
                activeLien.value?.lienId === lien.lienId && panelOpen.value
                  ? 'bg-green-50 hover:bg-green-50 border-l-4 border-l-green-600'
                  : bulkErrors.value[lien.lienId]
                    ? 'bg-[rgba(var(--v-theme-error),0.08)] hover:!bg-[rgba(var(--v-theme-error),0.08)] border-l-4 border-l-[rgb(var(--v-theme-error))]'
                    : _unref(isSelected)(lien.lienId)
                      ? 'bg-green-50 hover:bg-green-50'
                      : '',
              ]),
                          "data-cy": _unref(isSelected)(lien.lienId) ? 'lien-row-selected' : 'lien-row',
                          onClick: ($event: any) => (openEdit(lien))
                        }, [
                          _createElementVNode("td", {
                            class: "px-4 py-3 w-10",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(LlCheckbox, {
                              "model-value": _unref(isSelected)(lien.lienId),
                              "aria-label": `Select ${lien.vendorDisplayName}`,
                              disabled: 
                    isRowSelectionLocked(lien) ||
                    (_unref(isPushed)(lien.status) && !_unref(canUndoLien)(lien))
                  ,
                              "data-cy": "lien-row-checkbox",
                              "onUpdate:modelValue": ($event: any) => (_unref(toggle)(lien.lienId))
                            }, null, 8, ["model-value", "aria-label", "disabled", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(lien.vendorDisplayName), 1)
                          ]),
                          _createElementVNode("td", _hoisted_25, _toDisplayString(lien.description || '—'), 1),
                          _createElementVNode("td", _hoisted_26, _toDisplayString(lien.lienTypeDisplayName), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatCurrency)(lien.originalAmount)), 1),
                          _createElementVNode("td", _hoisted_28, [
                            (lien.negotiatedAmount != null)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_unref(formatCurrency)(lien.negotiatedAmount)), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(lien.currentAmount)) + " ", 1),
                            (lien.negotiatedAmount != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(formatCurrency)(lien.savings)) + " (" + _toDisplayString(Number(lien.savingsPercentage).toFixed(2)) + "%) ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'text-gray-300': !lien.dateOfService })
                            }, _toDisplayString(fmtDate(lien.dateOfService)), 3)
                          ]),
                          _createElementVNode("td", _hoisted_33, [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'text-gray-300': !lien.dateOfServiceEnd })
                            }, _toDisplayString(fmtDate(lien.dateOfServiceEnd)), 3)
                          ]),
                          _createElementVNode("td", _hoisted_34, [
                            _createVNode(LlTooltip, {
                              location: "top",
                              disabled: !_unref(isSettlementLocked) && !_unref(isPushed)(lien.status)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(isSettlementLocked) ? _unref(lockTooltip) : pushedStatusTooltip), 1)
                              ]),
                              activator: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "inline-flex",
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    disabled: _unref(isSettlementLocked) || _unref(isPushed)(lien.status)
                                  }, {
                                    activator: _withCtx(({ props: statusMenuProps }) => [
                                      _createVNode(_component_v_chip, _mergeProps({ ref_for: true }, statusMenuProps, {
                                        size: "small",
                                        rounded: "pill",
                                        disabled: _unref(isSettlementLocked) || _unref(isPushed)(lien.status),
                                        class: ["lien-status-badge font-weight-medium", [
                        `lien-status--${lien.status.toLowerCase()}`,
                        (_unref(isSettlementLocked) || _unref(isPushed)(lien.status)) ? '' : 'cursor-pointer',
                      ]],
                                        "data-cy": "lien-status-chip"
                                      }), {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(LIEN_STATUS_LABELS)[lien.status.toLowerCase()] ?? lien.status) + " ", 1),
                                          _createVNode(_component_v_icon, {
                                            size: "12",
                                            class: "lien-status-caret"
                                          }, {
                                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                              _createTextVNode("mdi-chevron-down", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1040, ["disabled", "class"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, {
                                        density: "compact",
                                        class: "!rounded-lg !shadow-xl min-w-[160px] !py-1"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LIEN_STATUS_OPTIONS), (opt) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: opt.value,
                                              class: _normalizeClass(['transition-colors', lien.status === opt.value ? 'font-semibold' : 'text-gray-700']),
                                              style: _normalizeStyle(lien.status === opt.value ? _unref(STATUS_STYLES)[opt.value] : {}),
                                              onClick: ($event: any) => (changeStatus(lien, opt.value))
                                            }, {
                                              prepend: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  class: "w-2 h-2 rounded-full flex-shrink-0 mr-2",
                                                  style: _normalizeStyle({ backgroundColor: _unref(STATUS_DOT_COLORS)[opt.value] ?? '#94a3b8' })
                                                }, null, 4)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "text-sm" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(opt.label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["class", "style", "onClick"]))
                                          }), 128)),
                                          (showQboColumn.value && _unref(isPushActionable)(lien))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_component_v_divider, { class: "my-1" }),
                                                _createVNode(_component_v_list_item, {
                                                  class: "text-primary",
                                                  "data-cy": "lien-status-push-action",
                                                  disabled: isRowPushing(lien.lienId),
                                                  onClick: ($event: any) => (handleRowPush(lien))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "flex items-center gap-1.5 text-sm" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(QboIcon, { size: 16 }),
                                                        _createTextVNode(" " + _toDisplayString(pushActionLabel(lien)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "onClick"])
                                              ], 64))
                                            : (showQboColumn.value && _unref(isPushBlocked)(lien))
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createVNode(_component_v_divider, { class: "my-1" }),
                                                  _createVNode(LienPushBlockedItem, {
                                                    reason: lien.pushBlockedReason ?? '',
                                                    "data-cy": "lien-status-push-action-blocked"
                                                  }, null, 8, ["reason"])
                                                ], 64))
                                              : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled"])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["disabled"]),
                            (showQboColumn.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (isRowPushing(lien.lienId) || isRowUndoing(lien.lienId))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createVNode(_component_v_progress_circular, {
                                          indeterminate: "",
                                          size: "12",
                                          width: "2",
                                          color: "success"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(isRowUndoing(lien.lienId) ? 'Undoing…' : 'Submitting...'), 1)
                                      ]))
                                    : (_unref(isPushed)(lien.status) && lien.qboTransactionId)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(lien.qboTransactionId), 1))
                                      : (_unref(pushBadgeState)(lien) === 'failed')
                                        ? (_openBlock(), _createBlock(LlSecondaryButton, {
                                            key: 2,
                                            variant: "text",
                                            color: "error",
                                            size: "x-small",
                                            class: "mt-1",
                                            "data-cy": "lien-error-details",
                                            onClick: _withModifiers(($event: any) => (openErrorDetail(lien)), ["stop"])
                                          }, {
                                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                              _createTextVNode(" Submit failed · Details ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                  (bulkErrors.value[lien.lienId])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createVNode(_component_v_icon, {
                                          size: "13",
                                          color: "error",
                                          class: "mt-0.5 flex-shrink-0"
                                        }, {
                                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                            _createTextVNode("mdi-alert-circle", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(bulkErrors.value[lien.lienId]), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", {
                            class: "px-6 py-3 text-center",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(LlTooltip, {
                              disabled: !isRowSelectionLocked(lien) || isRowPushing(lien.lienId) || isRowUndoing(lien.lienId),
                              location: "left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_40, _toDisplayString(lien.undoBlockedReason || lien.pushBlockedReason || 'This lien is locked and cannot be edited or acted on right now.'), 1)
                              ]),
                              activator: _withCtx(() => [
                                _createVNode(_component_v_menu, null, {
                                  activator: _withCtx(({ props: menuProps }) => [
                                    _createVNode(LlSecondaryButton, _mergeProps({
                                      icon: "mdi-dots-vertical",
                                      variant: "text",
                                      size: "small",
                                      density: "comfortable",
                                      "aria-label": "Lien actions"
                                    }, { ref_for: true }, menuProps, {
                                      disabled: isRowSelectionLocked(lien) || isRowPushing(lien.lienId) || isRowUndoing(lien.lienId),
                                      "data-cy": "lien-actions"
                                    }), null, 16, ["disabled"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          disabled: _unref(isSettlementLocked),
                                          onClick: ($event: any) => (openEdit(lien))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                _createTextVNode("Edit", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"]),
                                        (showQboColumn.value && _unref(isPushActionable)(lien))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              class: "text-primary",
                                              "data-cy": "lien-push-action",
                                              disabled: isRowPushing(lien.lienId),
                                              onClick: ($event: any) => (handleRowPush(lien))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "flex items-center gap-1.5" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(QboIcon, { size: 16 }),
                                                    _createTextVNode(" " + _toDisplayString(pushActionLabel(lien)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "onClick"]))
                                          : (showQboColumn.value && _unref(isPushBlocked)(lien))
                                            ? (_openBlock(), _createBlock(LienPushBlockedItem, {
                                                key: 1,
                                                reason: lien.pushBlockedReason ?? '',
                                                "data-cy": "lien-push-action-blocked"
                                              }, null, 8, ["reason"]))
                                            : _createCommentVNode("", true),
                                        (showQboColumn.value && _unref(canUndoLien)(lien))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 2,
                                              "data-cy": "lien-undo-action",
                                              disabled: isRowUndoing(lien.lienId),
                                              onClick: ($event: any) => (handleRowUndo(lien))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "flex items-center gap-1.5" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "16" }, {
                                                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                        _createTextVNode("mdi-undo", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[26] || (_cache[26] = _createTextVNode(" Undo Submit ", -1))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["disabled", "onClick"]))
                                          : (showQboColumn.value && _unref(isPushed)(lien.status))
                                            ? (_openBlock(), _createBlock(LlTooltip, {
                                                key: 3,
                                                location: "left"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_41, _toDisplayString(lien.undoBlockedReason || 'This lien cannot be undone right now.'), 1)
                                                ]),
                                                activator: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, {
                                                    class: "text-gray-400",
                                                    "data-cy": "lien-undo-action-blocked"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "flex items-center gap-1.5" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { size: "16" }, {
                                                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                              _createTextVNode("mdi-undo", -1)
                                                            ]))]),
                                                            _: 1
                                                          }),
                                                          _cache[28] || (_cache[28] = _createTextVNode(" Undo Push ", -1))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                        (!_unref(isPushed)(lien.status))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 4,
                                              class: "text-error",
                                              disabled: _unref(isSettlementLocked),
                                              "data-cy": "lien-delete-action",
                                              onClick: ($event: any) => (confirmDelete(lien))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                    _createTextVNode("Delete", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["disabled", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["disabled"])
                          ])
                        ], 10, _hoisted_22))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(SimplePagination, {
                  "current-page": currentPage.value,
                  "per-page": _unref(lienStore).pagination.limit,
                  "total-items": _unref(count),
                  offset: _unref(lienStore).pagination.offset,
                  "hide-show-all": true,
                  onPagechanged: onPageChange
                }, null, 8, ["current-page", "per-page", "total-items", "offset"])
              ])
            ], 64)),
    _createVNode(LlConfirmationDialog, {
      ref_key: "deleteConfirmRef",
      ref: deleteConfirmRef,
      title: "Delete Lien",
      message: deleteMessage.value,
      "confirm-text": "Delete",
      "toggle-text": "Cancel",
      "confirm-color": "error",
      "show-warning-icon": true,
      "data-cy": "delete-lien-confirmation"
    }, null, 8, ["message"]),
    _createVNode(LlConfirmationDialog, {
      ref_key: "undoConfirmRef",
      ref: undoConfirmRef,
      title: "Undo Submit",
      message: undoDialog.value.message,
      "confirm-text": "Delete Check & Undo Submit",
      "toggle-text": "Cancel",
      "confirm-color": "error",
      "show-warning-icon": true,
      "preserve-newlines": "",
      "data-cy": "undo-push-confirmation"
    }, null, 8, ["message"]),
    _createVNode(LienPushConfirmDialog, {
      ref_key: "pushConfirmRef",
      ref: pushConfirmRef
    }, null, 512),
    _createVNode(LienPushErrorDialog, {
      ref_key: "pushErrorRef",
      ref: pushErrorRef
    }, null, 512),
    _createVNode(LienBulkPushPreviewDialog, {
      ref_key: "bulkPushPreviewRef",
      ref: bulkPushPreviewRef
    }, null, 512),
    _createVNode(LlConfirmationDialog, {
      ref_key: "bulkUndoConfirmRef",
      ref: bulkUndoConfirmRef,
      title: "Undo Submit for Selected Liens",
      message: bulkUndo.value.message,
      "confirm-text": "Delete Checks & Undo Submit",
      "toggle-text": "Cancel",
      "confirm-color": "error",
      "show-warning-icon": true,
      "data-cy": "bulk-undo-confirmation"
    }, null, 8, ["message"]),
    _createVNode(LlConfirmationDialog, {
      ref_key: "bulkDeleteConfirmRef",
      ref: bulkDeleteConfirmRef,
      title: "Delete Selected Liens",
      message: `Delete ${_unref(pluralizeWithCount)(_unref(selectedIds).length, 'lien')}? This cannot be undone.`,
      "toggle-text": "Cancel",
      "confirm-text": "Delete",
      "show-warning-icon": false,
      "data-cy": "bulk-delete-dialog"
    }, null, 8, ["message"])
  ]))
}
}

})